// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/dynamic-form-choice-schema',
  type: 'object',
  required: ['orderSequence'],
  nullable: true,
  properties: {
    description: {
      type: 'string',
      nullable: true,
    },
    value: {
      type: 'string',
      nullable: true,
    },
    orderSequence: {
      type: 'integer',
    },
    isChosenByDefault: {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
